import { apiWrapper } from "@/services/api";

export const postTransfer = async (key) => {
  try {
    await apiWrapper("POST", `transferred_book_groups?key=${key}`);
  } catch (err) {
    console.log('ERROR"" postTransferKey()');
    throw err;
  }
};
